import React from 'react';
import { Form } from 'react-bootstrap';
import './PriceRangeFilter.css';

const MAX_MIN_PRICE = 9999;

const PriceRangeFilter = ({ minPrice, maxPrice, minValue = 0, maxValue = 10000, onMinChange, onMaxChange, onPriceEnd }) => {
  // Allow empty string while typing; only parse/cap on blur or slider
  const handleMinChange = (e) => {
    const raw = e.target.value;
    if (raw === '') {
      onMinChange && onMinChange('');
      return;
    }
    const value = parseInt(raw, 10);
    if (Number.isNaN(value)) return;
    const capped = Math.min(MAX_MIN_PRICE, Math.max(minValue, value));
    onMinChange && onMinChange(capped);
  };

  const handleMaxChange = (e) => {
    const raw = e.target.value;
    if (raw === '') {
      onMaxChange && onMaxChange('');
      return;
    }
    const value = parseInt(raw, 10);
    if (Number.isNaN(value)) return;
    const capped = Math.min(maxValue, Math.max(minValue, value));
    onMaxChange && onMaxChange(capped);
  };

  const handleInputBlur = () => {
    onPriceEnd && onPriceEnd();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') e.preventDefault();
  };

  const stopPropagationOnly = (e) => {
    e.stopPropagation();
  };

  const handleMinSliderChange = (e) => {
    const value = parseInt(e.target.value, 10) || 0;
    const capped = Math.min(MAX_MIN_PRICE, Math.max(minValue, value));
    onMinChange && onMinChange(capped);
  };

  const handleMaxSliderChange = (e) => {
    const value = parseInt(e.target.value, 10) || maxValue;
    const capped = Math.min(maxValue, Math.max(minValue, value));
    onMaxChange && onMaxChange(capped);
  };

  const minNum = minPrice === '' || minPrice === null || minPrice === undefined ? minValue : Number(minPrice);
  const maxNum = maxPrice === '' || maxPrice === null || maxPrice === undefined ? maxValue : Number(maxPrice);
  const minPercent = (minNum / maxValue) * 100;
  const maxPercent = (maxNum / maxValue) * 100;
  const activeRangeLeft = minPercent;
  const activeRangeWidth = maxPercent - minPercent;

  return (
    <div
      className="price-range-wrapper"
      onClick={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
    >
      <div className="price-inputs-row">
        <Form.Group className="price-input-group">
          <Form.Label>Min price</Form.Label>
          <Form.Control
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            placeholder="0"
            value={minPrice === '' || minPrice === null || minPrice === undefined ? '' : minPrice}
            onChange={handleMinChange}
            onBlur={handleInputBlur}
            onKeyDown={handleKeyDown}
            onClick={stopPropagationOnly}
            onTouchStart={stopPropagationOnly}
            className="price-input"
            min={minValue}
            max={MAX_MIN_PRICE}
          />
        </Form.Group>
        <Form.Group className="price-input-group">
          <Form.Label>Max price</Form.Label>
          <Form.Control
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            placeholder={maxValue.toString()}
            value={maxPrice === '' || maxPrice === null || maxPrice === undefined ? '' : maxPrice}
            onChange={handleMaxChange}
            onBlur={handleInputBlur}
            onKeyDown={handleKeyDown}
            onClick={stopPropagationOnly}
            onTouchStart={stopPropagationOnly}
            className="price-input"
            min={minValue}
            max={maxValue}
          />
        </Form.Group>
      </div>
      <div className="dual-range-slider">
        <div className="slider-track"></div>
        <div 
          className="slider-active-range"
          style={{
            left: `${activeRangeLeft}%`,
            width: `${activeRangeWidth}%`
          }}
        ></div>
        <input
          type="range"
          min={minValue}
          max={MAX_MIN_PRICE}
          step="100"
          value={minNum}
          onChange={handleMinSliderChange}
          onMouseUp={onPriceEnd}
          onPointerUp={onPriceEnd}
          onTouchEnd={onPriceEnd}
          className="range-input range-input-min"
        />
        <input
          type="range"
          min={minValue}
          max={maxValue}
          step="100"
          value={maxNum}
          onChange={handleMaxSliderChange}
          onMouseUp={onPriceEnd}
          onPointerUp={onPriceEnd}
          onTouchEnd={onPriceEnd}
          className="range-input range-input-max"
        />
      </div>
    </div>
  );
};

export default PriceRangeFilter;



